import React from 'react';
import { Helmet } from "react-helmet-async";
import { useI18n } from "../../i8n/useI18n";
import ContactSection from "../sections/contact/contactSection/ContactSection";

const ContactPage = () => {
    const { t } = useI18n();

    return (
        <>
            <Helmet>
                <title>{t("contactPage.title")} | {t("brand.name")}</title>
                <meta name="description" content={t("contactPage.description")} />
            </Helmet>
            <ContactSection />
        </>
    );
};

export default ContactPage;
